import type { PageTour } from '../types';

export const knowledgeTour: PageTour = {
  id: 'knowledge',
  label: 'Knowledge Base Tour',
  steps: [
    {
      target: '[data-tour="knowledge-header"]',
      title: 'Knowledge Base',
      content: 'Your organization\'s knowledge hub. Find documentation, guides, and articles organized by project.',
    },
    {
      target: '[data-tour="knowledge-search"]',
      title: 'Search Articles',
      content: 'Quickly find articles and documentation using the search bar. Results update as you type.',
    },
    {
      target: '[data-tour="knowledge-projects"]',
      title: 'Knowledge Projects',
      content: 'Articles are organized into projects. Click a project to browse its documentation and guides.',
    },
  ],
};
